import styled from 'styled-components';
import { Typography } from '../../shared-components/atomic-components';

interface LayoutTitleProps {
  className?: string;
  title: string;
  actions?: React.ReactNode;
}

export const LayoutTitle: React.FC<LayoutTitleProps> = ({ className, title, actions }) => {
  return (
    <S.Container data-testid="title" className={className}>
      <S.Title>{title}</S.Title>
      {actions}
    </S.Container>
  );
};

const S = {
  Container: styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    align-items: center;
    width: 100%;
    margin-bottom: 24px;
  `,
  Title: styled(Typography.H1)`
    display: flex;
    align-items: center;
    align-self: flex-start;
    height: 100%;
  `,
};
